// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  url: {
    // ihsUrl: 'https://ihs-api.aziro.app/',
    // wowUrl: 'https://wow-api.aziro.app/',
    // ihsUrl: 'https://ihs-staging.mobinius.net/api/',
    // wowUrl: 'https://wow-staging.mobinius.net/api/',

    ihsUrl: process.env.IHS_DEV_URL,
    wowUrl: process.env.WOW_DEV_URL,

    // ihsUrl: 'http://localhost:8001/',
    //   wowUrl: 'http://localhost:6001/',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
